import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import EmberObject, { action } from '@ember/object';
import { A } from '@ember/array';
import { tracked } from '@glimmer/tracking';
import { later } from '@ember/runloop';

import { FeedTypes } from 'mewe/constants';
import Storage from 'mewe/shared/storage';
import { isPresent } from '@ember/utils';
import { getConfigCatFlagPromise } from 'mewe/shared/config-cat';

export default class MwFeedFilter extends Component {
  @service settings;
  @service dynamicDialogs;
  @service features;

  @tracked scope;
  @tracked filter = this.args.filter;
  feedTypes = FeedTypes;

  get feeds() {
    let feeds = A([
      EmberObject.create({
        name: __('All'),
        scope: this.features.isEnabled('web__is_one_feed_enabled') ? FeedTypes.ONE_FEED : FeedTypes.ALL,
        visible: true,
      }),
      EmberObject.create({
        name: __('Following'),
        scope: FeedTypes.CONTACTS,
        visible: true,
      }),
      EmberObject.create({
        name: __('Favorites'),
        scope: FeedTypes.FAVORITES,
        visible: true,
        filter: FeedTypes.FAVORITES,
      }),
      EmberObject.create({
        name: __('Discover'),
        scope: FeedTypes.DISCOVER,
        visible: true,
      }),
    ]);

    if (!this.features.isEnabled('web__is_one_feed_enabled')) {
      feeds.splice(2, 1);
    }

    return feeds.filter((feed) => feed.visible);
  }

  get selectedFeed() {
    return this.feeds.find((f) => f.scope === this.scope);
  }

  get contactObject() {
    return this.feeds.find((f) => f.scope === FeedTypes.CONTACTS);
  }

  @action
  async initScope() {
    // flags are not updated yet after register, so we need to check if the flag is in the flags array
    const flagEnabled = await getConfigCatFlagPromise('web__is_one_feed_enabled');

    // myworld route is also awaiting for flag value to set proper scope,
    // postponing code here to be sure that correct scope is passed from route
    later(() => {
      const type = flagEnabled ? FeedTypes.ONE_FEED : FeedTypes.ALL;

      this.scope = this.args.scope ?? type;

      if (this.flagEnabled && this.scope === FeedTypes.CONTACTS) {
        this.filter = this.feedTypes.FAVORITES;
      }
    }, 10);
  }

  @action
  setFeedScope(feedType) {
    this.scope = feedType.scope;
    // get last state of filter from storage, we want to keep it for CONTACTS feed after switching feeds
    let feedParams = {
      scope: feedType.scope,
      filter: null,
    };

    if (feedType.scope === this.feedTypes.CONTACTS && Storage.get(Storage.keys.filterFavoritesInContacts)) {
      feedParams.filter = this.feedTypes.FAVORITES;
    }

    if (feedType.scope === this.feedTypes.FAVORITES) {
      feedParams.scope = this.feedTypes.CONTACTS;
      feedParams.filter = this.feedTypes.FAVORITES;
    }

    this.args.setFeedParams(feedParams);
  }

  @action
  setFeedFilter() {
    // toggle filter values {this.feedTypes.FAVORITES | null}
    Storage.set(Storage.keys.filterFavoritesInContacts, !this.args.filter);
    this.args.setFeedParams({ filter: this.args.filter ? null : this.feedTypes.FAVORITES });
  }
}
